import { render } from "./AdminSettingModal.vue?vue&type=template&id=fa492d78"
import script from "./AdminSettingModal.vue?vue&type=script&lang=js"
export * from "./AdminSettingModal.vue?vue&type=script&lang=js"

import "./AdminSettingModal.vue?vue&type=style&index=0&id=fa492d78&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__